module.exports = __webpack_public_path__ + "static/img/music_jkfa_icon.png";